import type { LucideProps } from 'lucide-react'

export function ChatIcon({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <rect width="18" height="18" x="3" y="3" rx="4" ry="4" className="stroke-current" />
            <path d="M8 10v4" />
            <path d="M12 8v8" />
            <path d="M16 10v4" />
            <path d="M5 11v2" />
            <path d="M19 11v2" />
        </svg>
    )
}

export function ChatIconGradient({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            {...props}
        >
            <defs>
                <linearGradient id="chat-icon-gradient" x1="3" y1="3" x2="21" y2="21" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2563EB" /> {/* blue-600 */}
                    <stop offset="1" stopColor="#9333EA" /> {/* purple-600 */}
                </linearGradient>
            </defs>
            <rect width="18" height="18" x="3" y="3" rx="4" ry="4" fill="url(#chat-icon-gradient)" />
            <path d="M8 10v4" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 8v8" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 10v4" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 11v2" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19 11v2" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
